module.exports = __webpack_public_path__ + "static/img/4nie.679885cf.webp";